import React, { ReactElement, useState, useEffect } from "react"
import { RouteComponentProps } from "@reach/router"
import { Spinner, Navigation, Filtering, Tile, Section } from "../../components"
import { useGetExperiencesByCategory } from "../../Hooks"
import { getTimeFromMin } from "../../lib"
import { sendPageTrackingEvent } from "../../services"

import styles from "./Search.scss"

const SearchPage = ({ location }: RouteComponentProps) => {
  const queryParams = location.search.split(/[=&]/)
  function renderTiles(children: Experience[]) {
    const sections: ReactElement[] = []
    children.forEach(
      (
        { name, price, sessions, sessionsNumber, pics }: Experience,
        i: number
      ) => {
        sections.push(
          <Tile
            key={name}
            index={i}
            title={name}
            duration={getTimeFromMin(
              sessions.map(s => s.duration).reduce((curr, acc) => acc + curr)
            )}
            picture={pics[0]}
            price={price}
            sessionsNumber={sessionsNumber}
          />
        )
      }
    )
    return (
      <div id="experiences">
        {sections.length === 0 ? "Aucune expérience trouvé" : sections}
      </div>
    )
  }

  const [loading, setLoading] = useState<boolean>(true)
  const [searchedLocation, setSearchedLocation] = useState<{
    lat: string
    lng: string
    description: string
  }>({
    lat: queryParams[5],
    lng: queryParams[7],
    description: decodeURI(queryParams[3])
  })
  const [radius, setRadius] = useState<number>(30)
  const [categories, setCategories] = useState<[string]>([])
  const [selectedCategory, setSelectedCategory] = useState<string>(
    decodeURI(queryParams[1]) || "Tous"
  )
  // const experiences = filterExperiencesByDate(filter, filterIndex, setLoading)
  sendPageTrackingEvent("Search")
  const experiences = useGetExperiencesByCategory(
    "",
    setLoading,
    selectedCategory,
    radius,
    searchedLocation
  )
  useEffect(() => {
    if (categories.length <= 2) {
      setCategories([
        ...new Set([...experiences.map(exp => exp.category), "Tous"])
      ])
      window.scrollTo(0, 0)
    }
  }, [experiences])
  return (
    <>
      <Navigation animated={false} />
      <Section title="VOICI LES RESULTATS CORRESPONDANTS A VOTRE RECHERCHE">
        {loading ? (
          <Spinner />
        ) : (
          <div className={styles.center}>
            <Filtering
              categories={categories}
              selectedCategory={selectedCategory}
              setSelectedCategory={setSelectedCategory}
              setSearchedLocation={setSearchedLocation}
              searchedLocation={searchedLocation}
            />
            <div>{renderTiles(experiences)}</div>
          </div>
        )}
      </Section>
    </>
  )
}

export default SearchPage
